import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { DirectionTypeEnum } from '@zaoblako/shared/modules/catalog/enums/direction.type.enum';

/**
 * Localized human-readable string representations of {@link DirectionTypeEnum} enumeration values
 */
export const DirectionTypeEnumI18n: Record<I18nLocalesEnum, Record<DirectionTypeEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [DirectionTypeEnum.AMOUNT]: 'Сумма',
    [DirectionTypeEnum.PERCENT]: 'Процент',
    [DirectionTypeEnum.CONSOLIDATED_AMOUNT]: 'Консолидированная сумма',
    [DirectionTypeEnum.CONSOLIDATED_PERCENT]: 'Консолидированный процент',
  },
  [I18nLocalesEnum.EN_US]: {
    [DirectionTypeEnum.AMOUNT]: 'Amount',
    [DirectionTypeEnum.PERCENT]: 'Percent',
    [DirectionTypeEnum.CONSOLIDATED_AMOUNT]: 'Consolidated Amount',
    [DirectionTypeEnum.CONSOLIDATED_PERCENT]: 'Consolidated Percent',
  },
};
